import React, { useState } from 'react';
import moment from 'moment';
import { Button, Badge } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import ViewReceipt from '../Orders/components/Modals/ViewReceipt';
import ViewInfoHistory from '../Orders/components/Modals/ViewInfoHistory';
import {
  IoInformationCircle,
  IoPrintOutline,
  IoDocumentTextOutline,
} from 'react-icons/io5';

const EINVOICE_PRINT_URL = process.env.REACT_APP_EINVOICE_PRINT_URL;

function HistoryGrid({ order }) {
  const [orderNew, setOrder] = useState(JSON.parse(order.orderjson));

  const [show, setShow] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const handleCloseReceipt = () => setShowReceipt(false);
  const handleShowReceipt = () => setShowReceipt(true);
  // View Info Handle

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handlePrintEInvoice = async () => {
    if (!order?.id) {
      toast.error('Order ID not found');
      return;
    }

    if (!EINVOICE_PRINT_URL) {
      toast.error('E-Invoice print URL not configured');
      return;
    }

    try {
      const response = await axios.get(EINVOICE_PRINT_URL, {
        params: {
          departmentInvoiceId: order.id,
          departmentName: 'SPA',
          outlet: null,
        },
      });

      if (response?.data?.response && response?.data?.url) {
        window.open(response.data.url, '_blank', 'noopener,noreferrer');
        return;
      }

      toast.error('Unable to open e-invoice');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Unable to print e-invoice');
    }
  };

  return (
    <>
      <tr key={order.id}>
        <td>{order?.id}</td>
        <td>{orderNew?.ecode}</td>
        <td>
          {moment(orderNew?.datetime_submitted).format('YYYY-MM-DD h:mm')}
        </td>
        <td>{moment(orderNew?.booking_date).format('YYYY-MM-DD')}</td>
        <td>{moment(orderNew?.datetime_closed).format('YYYY-MM-DD')}</td>
        <td>{order?.tip}</td>
        <td>
          {order?.payment_detail.length > 0
            ? order?.payment_detail.map((item, index) => {
                return (
                  <Badge pill bg="dark" className="m-1 p-2" key={index}>
                    {item.TransactionId}
                  </Badge>
                );
              })
            : 'N/A'}
        </td>
        {/* <td>{order?.payment_detail[0]?.TransactionId ?? 'N/A'}</td> */}
        <td>{orderNew?.payment_type ?? 'N/A'}</td>
        <td>{orderNew?.subtotal ?? 'N/A'}</td>
        <td>{orderNew?.vat ?? 'N/A'}</td>
        <td>{orderNew?.total ?? 'N/A'}</td>
        <td>
          <Button
            className="order-btn m-1"
            variant="light"
            onClick={handleShow}
          >
            <IoInformationCircle className="icon-class" />
          </Button>
          <Button variant="light" id="getHistory" onClick={handleShowReceipt}>
            <IoPrintOutline className="icon-class" />
          </Button>
          <Button
            variant="light"
            id="getHistory"
            onClick={handlePrintEInvoice}
            title="Print E-Invoice"
          >
            <IoDocumentTextOutline className="icon-class" />
          </Button>
        </td>
      </tr>

      {/* Modal Receipt */}
      <ViewReceipt
        order={orderNew}
        showReceipt={showReceipt}
        handleCloseReceipt={handleCloseReceipt}
      />
      {/* Modal Receipt */}
      {/* Order Info History*/}
      <ViewInfoHistory order={orderNew} handleClose={handleClose} show={show} />
    </>
  );
}

export default HistoryGrid;
